import styled from "@emotion/styled";
import { Cancel01Icon } from "@porchpass/ui";
import { SettingsIcon } from "src/assets/icons";
import { GhostButton } from "src/components/Buttons";
import { LIGHT_BACKGROUND } from "src/constants/colors";
import { useLocation, useNavigate } from "react-router-dom";
import { useDealer } from "src/hooks/useDealer";

export const HeaderContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px 80px;
  background-color: ${LIGHT_BACKGROUND};
`;

export const HeaderDescription = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.6%;
`;

export default () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { dealer_id } = useDealer();
  const returnTo = (location.state as { returnTo?: string } | null)?.returnTo;
  const closeTo =
    returnTo && !returnTo.includes("/dealer-settings")
      ? returnTo
      : `/${dealer_id}`;

  return (
    <HeaderContainer>
      <HeaderDescription>
        <SettingsIcon />
        Dealer Settings
      </HeaderDescription>
      <GhostButton
        initialBg={false}
        onClick={() => {
          void navigate(closeTo, { replace: true });
        }}
      >
        Close
        <span className="inline-flex h-3.5 w-3.5 shrink-0 items-center justify-center">
          <Cancel01Icon size={14} />
        </span>
      </GhostButton>
    </HeaderContainer>
  );
};
